import React, { HTMLAttributes } from 'react';
import { placeholderBaseStyle } from '~ui-kit/components/placeholders/placeholder-resources';
import { styled } from '~ui-kit/styled-components';
import { styledWidth, StyledWidthProps } from '~ui-kit/theme/styled-system';

export interface PlaceholderPillProps extends StyledWidthProps, HTMLAttributes<HTMLDivElement> {}

export function PlaceholderPill(props: PlaceholderPillProps) {
  return <StyledPlaceholderPill {...props} />;
}

const StyledPlaceholderPill = styled.div<PlaceholderPillProps>`
  ${styledWidth}
  ${placeholderBaseStyle}
  height: 32px;
  border-radius: 100px;
`;
